import React from 'react';
import ReactDOM from 'react-dom/client';
import { ClerkProvider } from '@clerk/react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;
if (!PUBLISHABLE_KEY) {
  throw new Error('Missing REACT_APP_CLERK_PUBLISHABLE_KEY in .env');
}

const clerkAppearance = {
  variables: {
    colorPrimary: '#7C3AED',
    colorBackground: '#0f172a',
    colorInputBackground: '#1e293b',
    colorInputText: '#ffffff',
    colorText: '#ffffff',
    colorTextSecondary: '#c4c9d4',
    colorTextOnPrimaryBackground: '#ffffff',
    borderRadius: '8px',
  },
  elements: {
    // Modal card
    card: {
      backgroundColor: '#0f172a',
      border: '1px solid #1e293b',
      boxShadow: '0 8px 32px rgba(0,0,0,0.6)',
    },
    // Left navbar
    navbar: {
      backgroundColor: '#0a0f1e',
      borderRight: '1px solid #1e293b',
    },
    navbarButton: { color: '#9ca3af' },
    navbarButtonActive: {
      color: '#ffffff',
      backgroundColor: 'rgba(124,58,237,0.15)',
    },
    // Page content area
    pageScrollBox: { backgroundColor: '#0f172a' },
    page: { backgroundColor: '#0f172a' },
    // Section titles
    profileSectionTitle: { color: '#ffffff' },
    profileSectionTitleText: { color: '#ffffff !important' },
    // Section content rows
    profileSectionContent: { color: '#e2e8f0' },
    profileSectionItem: { color: '#e2e8f0' },
    profileSectionPrimaryButton: { color: '#a78bfa' },
    // Form fields
    formFieldLabel: { color: '#9ca3af' },
    formFieldInput: {
      backgroundColor: '#1e293b',
      color: '#ffffff',
      borderColor: '#334155',
    },
    formFieldInputShowPasswordButton: { color: '#9ca3af' },
    // Identifiers (email, name) — the key fix
    identityPreview: { color: '#e2e8f0' },
    identityPreviewText: { color: '#e2e8f0 !important' },
    identityPreviewEditButton: { color: '#a78bfa' },
    // Table rows in profile sections
    tableHead: { color: '#9ca3af' },
    tableCell: { color: '#e2e8f0' },
    // Hover states — prevent dark-on-dark
    profileSectionItemActionButton: {
      color: '#e2e8f0',
      '&:hover': { color: '#ffffff', backgroundColor: 'rgba(124,58,237,0.15)' },
    },
    accordionTriggerButton: {
      color: '#e2e8f0',
      '&:hover': { color: '#ffffff' },
    },
    // Badges
    badge: {
      backgroundColor: 'rgba(124,58,237,0.2)',
      color: '#a78bfa',
    },
    // Dropdown popup
    userButtonPopoverCard: {
      backgroundColor: '#0f172a',
      border: '1px solid #1e293b',
      boxShadow: '0 8px 32px rgba(0,0,0,0.4)',
    },
    userButtonPopoverActionButton: {
      color: '#ffffff',
      '&:hover': { backgroundColor: 'rgba(124,58,237,0.15)', color: '#ffffff' },
    },
    userButtonPopoverActionButtonText: { color: '#ffffff' },
    userPreviewMainIdentifier: { color: '#ffffff' },
    userPreviewSecondaryIdentifier: { color: '#9ca3af' },
  },
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ClerkProvider
      publishableKey={PUBLISHABLE_KEY}
      appearance={clerkAppearance}
    >
      <App />
    </ClerkProvider>
  </React.StrictMode>
);

reportWebVitals();
